module.exports = __webpack_public_path__ + "media/icons/icon_navi-137af941.png";